import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCeleryComponent } from './simple-icons-celery.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCeleryComponent ],
    exports:      [ SimpleIconsCeleryComponent ],
    bootstrap:    []
})
export class SimpleIconsCeleryModule {}
